import { isNotEmpty, toSportUrlCase } from 'utility/functions';

import { AnchorLink } from 'components/anchorLink';
import { DynamicImage, enLoading } from 'components/Image';
import React from 'react';
import { SportsCompetitor } from 'types/swagger';
import styles from './AvailableStreamCardBody.module.scss';
import { useTranslation } from 'hooks/useLingUI';
import classNames from 'classnames';
import useWindowSize from 'hooks/useWindowSize';

export type AvailableStreamCardBodyProps = {
  dataList: Array<SportsCompetitor | Score>;
  children?: React.ReactNode;
  urlAvvenimento?: string;
};

export type Score = { score: string };

export const AvailableStreamCardBody = ({ ...props }: AvailableStreamCardBodyProps) => {
  const { isDesktop } = useWindowSize();
  const hasMultiCompetitors = (index: number, array: Array<SportsCompetitor | Score>): boolean => {
    if (array.length === 3) return true;
    return false;
  };

  const { t } = useTranslation();

  return (
    <AnchorLink
      href={toSportUrlCase(props.urlAvvenimento)}
      className={classNames(styles.bodyContainer, { [styles.bodyContainerCenter]: props.dataList.length === 1 })}
    >
      {props.dataList.map((item: SportsCompetitor | Score, index: number, self) => {
        if (index === 1) {
          let scoreItem = item as Score;
          return (
            scoreItem && (
              <strong
                key={scoreItem.score}
                className={classNames(styles.score, { [styles.scoreCenter]: scoreItem.score?.length === 1 })}
                suppressHydrationWarning
              >
                {scoreItem.score?.length > 1 ? (
                  <React.Fragment>
                    <span suppressHydrationWarning>{scoreItem.score[0]}</span>
                    {isDesktop && <span suppressHydrationWarning>{scoreItem.score[1]}</span>}
                    <span suppressHydrationWarning>{scoreItem.score[2]}</span>
                  </React.Fragment>
                ) : (
                  isDesktop && scoreItem.score
                )}
              </strong>
            )
          );
        }
        let competitor = item as SportsCompetitor;
        return (
          <div
            key={competitor.descrizione + '-' + index}
            className={`${styles.wrapperCompetitor} ${
              hasMultiCompetitors(index, self) ? styles.multipleCompetitor : styles.singleCompetitor
            }`}
          >
            {isNotEmpty(competitor?.iconSrc) && (
              <div className={styles.imageContainer}>
                <DynamicImage
                  src={`${competitor?.iconSrc}`}
                  alt={competitor?.descrizione ?? ''}
                  fill
                  loading={enLoading.lazy}
                  decoding="async"
                  className={styles.image}
                />
              </div>
            )}
            <span className={styles.label}>{t(competitor.descrizioneTrKey, competitor.descrizione)}</span>
          </div>
        );
      })}
    </AnchorLink>
  );
};
